import { render, staticRenderFns } from "./CAxARPxPersonalityPage.vue?vue&type=template&id=6bf1d547"
import script from "./CAxARPxPersonalityPage.vue?vue&type=script&lang=js"
export * from "./CAxARPxPersonalityPage.vue?vue&type=script&lang=js"
import style0 from "./CAxARPxPersonalityPage.vue?vue&type=style&index=0&id=6bf1d547&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports